import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    toasts: any[] = [];
    show(message: string, options: any = {}): void {
        const existingToast = this.toasts.find((t) => t.message === message);
        if (existingToast) {
            existingToast.show = true;
        } else {
            options.show = true;
            this.toasts.push({ message, ...options });
        }
    }
    // ⚠️ WRONG / WARNING (Yellow)
    warning(message: string): void {
        this.show(message, {
            classname: 'bg-warning text-dark',
            delay: 3000
        });
    }
    // ℹ️ INFO (Blue) → DigiLocker in-progress
    info(message: string): void {
        this.show(message, {
            classname: 'text-white',
            style: 'background-color:#1a73e8',
            delay: 3000
        });
    }

    // ✅ SUCCESS (Green) → DigiLocker fetched
    success(message: string): void {
        this.show(message, {
            classname: 'bg-success text-white',
            delay: 3000
        });
    }


    remove(toast: any): void {
        this.toasts = this.toasts.filter((t) => t !== toast);
    }
    constructor() {
        setInterval(() => {
            this.toasts.forEach((value: any, index: number, array: any[]) => {
                setTimeout(() => { this.remove(value) }, 1000 * (index + 1))
            })
        }, 10000)
    }
}
